// extracted by mini-css-extract-plugin
export default {"qrCodeBlock":"QRcode_qrCodeBlock__gor7G","qrBlockImg":"QRcode_qrBlockImg__J68EI","logoBlock":"QRcode_logoBlock__+-T+M"};